import { useState } from 'react';
import { Button } from 'semantic-ui-react';
import CreateDealModal from '~/modals/CreateDealModal';
import { useUserContext } from '~/hooks';

export default function CreateProject() {
  const { loggedInUser } = useUserContext();
  const [showModal, setShowModal] = useState(false);

  return (
    <div>
      {(loggedInUser?.isInstaller || loggedInUser?.isAdmin) && (
        <>
          <Button
            primary
            size="small"
            style={{ display: 'flex', alignItems: 'center', gap: '0.2rem' }}
            onClick={() => setShowModal(true)}
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-plus" viewBox="0 0 16 16">
              <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4" />
            </svg>
            <span style={{ marginRight: '.2rem' }}>Create deal</span>
          </Button>
          {showModal && (
            <CreateDealModal closeModal={() => setShowModal(false)} />
          )}
        </>
      )}
    </div>
  );
}
